import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-oficina-mecanica")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-oficina-mecanica"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-oficina-mecanica"]!.metaDescription,
    path: "/agente-ia-oficina-mecanica",
  }),
  component: () => <SegmentRoute slug="agente-ia-oficina-mecanica" />,
});
